<template>
    <svg
        height="24px"
        width="24px"
        id="percent"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 29.555 28"
        style="fill: currentColor"
    >
        <path
            id="Tracé_65"
            data-name="Tracé 65"
            d="M75.491,7.111a1.684,1.684,0,0,0-2.264.738L60.7,32.481a1.684,1.684,0,1,0,3,1.526L76.229,9.375A1.684,1.684,0,0,0,75.491,7.111Z"
            transform="translate(-53.727 -6.928)"
        />
        <path
            id="Tracé_66"
            data-name="Tracé 66"
            d="M12.772,30.314A6.386,6.386,0,1,0,6.386,36.7,6.394,6.394,0,0,0,12.772,30.314ZM6.386,33.333A3.019,3.019,0,1,1,9.4,30.314,3.022,3.022,0,0,1,6.386,33.333Z"
            transform="translate(0 -22.02)"
        />
        <path
            id="Tracé_67"
            data-name="Tracé 67"
            d="M155.892,125.58a6.386,6.386,0,1,0,6.386,6.386A6.394,6.394,0,0,0,155.892,125.58Zm0,9.4a3.018,3.018,0,1,1,3.018-3.018A3.022,3.022,0,0,1,155.892,134.985Z"
            transform="translate(-132.723 -112.261)"
        />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-tva",
});
</script>
